<template>
  <v-card :loading="loading" flat v-if="availableIds.length || unavailableIds.length">
    <v-card-title v-if="$vuetify.breakpoint.mdAndUp"
      >{{ "Assessment" | pluralTerm }} to delete.
    </v-card-title>
    <v-card-text>
      <sr-available-ids
        entity="Assessment"
        label="Delete requests"
        :availableIds="availableIds"
        :unavailableIds="unavailableIds"
        :items="assessments"
        :loading="disabled"
      ></sr-available-ids>
    </v-card-text>

    <v-card-actions v-if="availableIds.length">
      <v-spacer></v-spacer>

      <v-btn text @click="batch" :disabled="loading || disabled" color="success">
        Delete {{ "assessment" | pluralTerm }}</v-btn
      >
    </v-card-actions>
    <v-card v-if="result">
      {{ result }}
    </v-card>
  </v-card>
  <v-card-text v-else class="text--center d-flex align-content-stretch">
    <em>Please select some {{ "assessment" | pluralTerm }} first</em>
  </v-card-text>
</template>

<script>
import srAvailableIds from "./AvailableIds.vue";

export default {
  name: "DeleteAssessments",
  components: {
    srAvailableIds,
  },
  data() {
    return {
      changes: 0,
      saving: false,
      showSelected: false,
      error: null,
      loading: false,
      result: null,
      chunkSize: 5,
    };
  },
  methods: {
    change() {
      this.changes = this.changes + 1;
    },
    batch() {
      const items = this.assessments.filter((a) => this.availableIds.includes(a.id));
      const groupGetter = this.$store.getters["saved/get"];
      const data = {
        request: {},
        includeSecret: true,
        items: items,
        url: "update/assessment/batch/delete",
        name: "assessment",
        dataProp: "assessments",
        titleProp: "assessmentTitle",
        action: "delete",
        chunkSize: this.chunkSize,
        emit: "searchAgain",
        clearSelection: true,
        csv: {
          title: `Deleted Assessment Results ${new Date()}`,
          headers: [
            {
              key: "Title",
              isItemProp: true,
              value: function (item) {
                return item["assessmentTitle"].replace(",", " ");
              },
            },
            {
              key: "Group",
              isItemProp: true,
              value: function (item) {
                var groupName = "";
                var group = groupGetter(["groups", item.groupId]);
                if (group) {
                  groupName = group.displayText;
                  if (group.internalId != null) {
                    groupName = `${groupName} (${group.internalId})`;
                  }
                  if (group.path && group.path.length) {
                    var paths = group.path
                      .map((x) => {
                        return x
                          ? {
                              level: x.level,
                              groups: x.groups
                                ? x.groups.map((g) => {
                                    var group = groupGetter(["groups", g]);
                                    var gt = groupGetter(["groupTypes", group.groupType]);
                                    return {
                                      id: g,
                                      name: group != null ? group.displayText : null,
                                      internalId: group != null ? group.internalId : null,
                                      groupType: gt != null ? gt.name : null,
                                      colour: group ? group.colour : "",
                                    };
                                  })
                                : [],
                            }
                          : null;
                      })
                      .sort(function (a, b) {
                        if (a.level < b.level) {
                          return -1;
                        }
                        if (a.level > b.level) {
                          return 1;
                        }
                        if (a.level === b.level) {
                          return 0;
                        }
                      })
                      .filter((y) => y);
                  }
                  var pathString = "";
                  if (paths[0] && paths[0].groups) {
                    paths[0].groups.forEach((p0) => {
                      if (pathString.length != 0) {
                        pathString = `${pathString}> ${p0.name}`;
                      } else {
                        pathString = `${pathString} ${p0.name}`;
                      }
                    });
                  }
                  if (paths[1] && paths[1].groups) {
                    paths[1].groups.forEach((p1) => {
                      pathString = `${pathString}> ${p1.name}`;
                    });
                  }
                  groupName = `${pathString}: ${groupName}`;
                }
                return groupName;
              },
            },
          ],
        },
      };
      this.$emit("setUpTask", data);
    },
    update() {
      var valid = window.confirm(
        `Are you sure you wish to delete ${this.availableIds.length} ${this.getTerm(
          "assessment",
          this.availableIds.length == 1 ? false : true
        )}? 
         This action is irreversible and all deleted ${this.getTerm(
           "assessment",
           true
         )} will be gone forever.`
      );
      if (valid) {
        this.loading = true;
        var data = {
          assessments: this.availableAssessments.map((x) => {
            return {
              id: x.id,
              secret: x.secret,
            };
          }),
          archived: this.archive,
        };
        debugger;
        this.$post("update/assessment/batch/archive", data).then((response) => {
          debugger;
          if (response.error) {
            this.error = response.text;
          } else {
            this.result = response;
            // this.$store.dispatch("saved/get_assessments");
            // this.reset();
          }
          this.loading = false;
        });
      }
    },
  },
  computed: {
    availableAssessments() {
      return this.assessments.filter((x) => this.availableIds.includes(x.id));
    },
  },
  props: {
    unavailableIds: {
      type: Array,
      default: () => [],
    },
    availableIds: {
      type: Array,
      default: () => [],
    },
    assessments: {
      type: Array,
      default: () => [],
    },
    archive: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
